import {CustomerLocationDTOModel} from './customerLocationDTO.model';
import { Injectable } from "@angular/core";

@Injectable()
export class PhotoDTOModel {
    public photoBase64: string;
    public lat: number;
    public lng: number;
    public serviceEnquiryWorklistId: number;
    public documentLocation: number;
    public location: CustomerLocationDTOModel;
    public documentType: number;
    public documentNumber: number;
    public customerRef: number;
    public photoURL: string;
    public filename: string;
    public documentId: number;
    public uploaded: boolean;
    public timeStamp: Date;
    public comment: string;

    [x: string]: any;
}
